const previewPanelStyle = {
    backgroundImage: 'radial-gradient(#E3E5E7 0.8px, #ffffff 0.8px)',
    backgroundSize: '16px 16px',
};

/**
 * Fake pages database.
 */
const pages = [
    {
        id: 'rY5N1UhM',
        title: 'Unity. Разработка игр. \nПробное занятие.',
        is_recurrent: false,
        default_regular_amount: 2990,
        payment_object: 'other',
    },
    {
        id: 'T8Ql3Pij',
        title: 'Курс «Python для начинающих»',
        is_recurrent: true,
        default_regular_amount: 990,
        default_first_amount: 1,
        once_per_days: 30,
        payment_object: 'service',
        external_fields: [
            {
                id: 1,
                form_id: 1,
                field_name: 'Optional dummy field 1',
                is_necessary: false,
            },
            {
                id: 2,
                form_id: 1,
                field_name: 'Mandatory dummy field 1',
                is_necessary: true,
            }
        ],
    }
];

const clients_db = [
    {
        id: 1,
        company_id: 1,
        email: 'callmistercat@gmail.com',
        phone_number: '89103897172',
        name: 'Алексндр Белов',
        masked_pan: '**** 4242',
        is_subscribed: false,
        created_at: '2022-08-01',
        updated_at: '2022-08-13',
        subsribed_at: null,
        deactivated_at: null,
        active: false,
    },
    {
        id: 2,
        company_id: 1,
        email: 'vikatsvits22@gmail.com',
        phone_number: '89204132121',
        name: 'Виктория Цвирко',
        masked_pan: '**** 4126',
        is_subscribed: false,
        created_at: '2022-08-01',
        updated_at: '2022-08-15',
        subsribed_at: null,
        deactivated_at: null,
        active: false,
    },
    {
        id: 3,
        company_id: 1,
        email: 'ganza.masha@gmail.com',
        phone_number: '89517308265',
        name: 'Мария Ганзина',
        masked_pan: '**** 3735',
        is_subscribed: true,
        created_at: '2022-08-01',
        updated_at: '2022-08-13',
        subsribed_at: '2022-08-01',
        deactivated_at: null,
        active: true,
    }
];

export { pages, clients_db, previewPanelStyle };
